<template>
  <div id="app">
    <headBack title="管理中心"></headBack>
    <div class="page">
      <centerInfo></centerInfo>
      <div class="app-msg">
        <div>
          <span class="app-msg-title">已开通聊天号</span>
          <span class="app-msg-num">{{code}}</span>
        </div>
        <div class="app-ba">
          <img src="../../assets/img/center-lo-1@2x.png" alt />
          <div class="app-ba-content">请选择一个伪装聊天APP下载使用</div>
        </div>
      </div>
      <div class="app-info">
        <div class="app-info-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-jisuanqi@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">智能计算器</span>
            <br />
            <span class="app-desc">
              -伪装成计算器，人畜无害
              <br />-但消息推送过于频繁可能引起怀疑
            </span>
            <br />
            <button @click="jisuan();upclick(1)">立即下载使用</button>
          </div>
          <div class="app-info-right">免费</div>
        </div>

        <div class="app-info-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-zhixuan@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">资讯APP</span>
            <br />
            <span class="app-desc">
              -伪装成今日头条，神不知鬼不觉
              <br />-有新消息时推送新闻，完全仿真
              <br />-高可靠应用
            </span>
            <br />
            <button @click="toNews();upclick(2)">立即下载使用</button>
          </div>
          <div class="app-info-right">VIP专享</div>
        </div>

        <div class="app-info-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-abc@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">背单词APP</span>
            <br />
            <span class="app-desc">
              -伪装成背单词APP，真的可以学习英语
              <br />-有新消息时推送单词考题
              <br />-积极向上的好学人设
            </span>
            <br />
            <button @click="shangxian();upclick(3)">即将上线</button>
          </div>
          <div class="app-info-right">VIP专享</div>
        </div>

        <div class="app-info-s">
          <div class="app-info-logo">
            <img src="../../assets/img/app-game@2x.png" alt />
          </div>
          <div class="app-info-content">
            <span class="app-name">游戏APP</span>
            <br />
            <span class="app-desc">
              -伪装成游戏APP
              <br />-有新消息时推送领金币
              <br />
-聊天时遇紧急情况，秒切至游戏页面
            </span>
            <button @click="shangxian();upclick(4)" >即将上线</button>
          </div>
          <div class="app-info-right">VIP专享</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import centerInfo from "../common/centerInfo";

import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "管理中心"
  },
  name: "app",
  data() {
    return {
      msg: "管理中心",
      code: null
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }

    this.code = this.$route.params.code;
  },
  methods: {
    upclick:function(tag){
      this.$point.eventtag(tag,"btn_100008");
    },
    jisuan: function() {
      
      this.$router.push("/userAppInfo?token=" + this.getToken);
    },
    toNews: function() {
      //
      /*
      var userInfo = this.getUserInfo;
      if (userInfo.viptype > 0) {
        //判断是否过期
        var nowtime = new Date();
        var validitydate = new Date(userInfo.validitydate);
        if (validitydate < nowtime) {
          tips.toast("您的会员已经过期");
          return;
        } else {
          this.$router.push("/userAppInfotxs?token=" + this.getToken);
        }
      } else {
        tips.toast("该软件付费后即可使用，请先购买会员");
        setTimeout(() => {
          this.$router.push("/pay");
        }, 2000);

        return;
      }
      */
     this.$router.push("/userAppInfotxs?token=" + this.getToken);
    },
    shangxian: function() {
      tips.toast("即将上线，敬请期待");
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  },
  components: {
    headBack,
    centerInfo
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: auto;
  background-image: url("../../assets/img/background@2x.png");
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
  padding: 28px 0px 0px 0px;
}

.app-msg {
  height: 100px;
  text-align: center;
  margin: 32px auto 44px auto;
}
.app-msg-title {
  width: 288px;
  height: 66px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 66px;
  background: linear-gradient(
    148deg,
    rgba(233, 205, 181, 1) 0%,
    rgba(214, 170, 150, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.app-msg-num {
  height: 66px;
  font-size: 46px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 66px;
  background: linear-gradient(
    148deg,
    rgba(233, 205, 181, 1) 0%,
    rgba(214, 170, 150, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.app-ba {
  width: 670px;
  height: 200px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0 auto;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -35px;
}

.app-info {
  width: 100%;
}
.app-info-s {
  width: 632px;
  height: 285px;
  display: flex;
  margin: 0 auto;
}

.app-info-logo {
  width: 122px;
  height: 122px;
}

.app-info-logo img {
  width: 122px;
  height: 122px;
}

.app-info-content {
  flex: 1;
  text-align: left;
  padding: 0px 0px 0px 36px;
}

.app-name {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 50px;
}

.app-desc {
  width: 474px;
  height: 115px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #7d779b;
  line-height: 40px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}

.app-info-content button {
  padding: 0;
  width: 210px;
  height: 48px;
  background: linear-gradient(90deg, #eeae91 0%, #f9dcc1 100%);
  border-radius: 24px;
  margin-top: 36px;
  border: none;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
}

.app-info-right {
  width: 140px;
  height: 30px;
  background: url("../../assets/img/app-info-right@2x.png") no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(127, 86, 47, 1);
  line-height: 30px;
  position: absolute;
  right: 68px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/userApplist.vue